import { render, staticRenderFns } from "./TableRestrictionPeriodCell.vue?vue&type=template&id=55e2e037&scoped=true&functional=true&"
import script from "./TableRestrictionPeriodCell.vue?vue&type=script&lang=js&"
export * from "./TableRestrictionPeriodCell.vue?vue&type=script&lang=js&"
import style0 from "./TableRestrictionPeriodCell.vue?vue&type=style&index=0&id=55e2e037&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "55e2e037",
  null
  
)

export default component.exports